var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, Divider, getTestId, InView, isFirstItem, isValidObject, Tooltip } from '@airtel/air-design-system';
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { FlatList, SectionList, View } from 'react-native';
import { GrowthInventoryWidgetComponent } from '../../components/growth-inventory-widget/GrowthInventoryWidget';
import { LoaderWidgetComponent } from '../../components/loader-widget/LoaderWidget';
import { SectionTitleWidgetComponent } from '../../components/section-title-widget/SectionTitleWidget';
import { getWithSectionListStyles } from './WithSectionListWidgetStyles';
export var withSectionList = Component => {
  var Wrapper = props => {
    var _props$withSectionLis = props.withSectionList,
      withSectionList = _props$withSectionLis === void 0 ? false : _props$withSectionLis,
      _props$withSectionLis2 = props.withSectionListProps,
      withSectionListProps = _props$withSectionLis2 === void 0 ? {} : _props$withSectionLis2,
      _props$withRNSectionL = props.withRNSectionListProps,
      withRNSectionListProps = _props$withRNSectionL === void 0 ? {} : _props$withRNSectionL,
      _props$withRNSectionL2 = props.withRNSectionList,
      withRNSectionList = _props$withRNSectionL2 === void 0 ? false : _props$withRNSectionL2,
      appendRNSectionItem = props.appendRNSectionItem,
      restProps = __rest(props, ["withSectionList", "withSectionListProps", "withRNSectionListProps", "withRNSectionList", "appendRNSectionItem"]);
    var _ref = withRNSectionListProps || {},
      dividerWithList = _ref.dividerWithList,
      dividerWithListStyle = _ref.dividerWithListStyle,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      section = _ref.section,
      onEndReachedThreshold = _ref.onEndReachedThreshold,
      onEndReachedMetaData = _ref.onEndReachedMetaData,
      loaderWidgetProps = _ref.loaderWidgetProps,
      appendSection = _ref.appendSection,
      rnSectionListHeaderProps = _ref.rnSectionListHeaderProps,
      onScrollMetaData = _ref.onScrollMetaData,
      _ref$contentContainer = _ref.contentContainerStyle,
      contentContainerStyle = _ref$contentContainer === void 0 ? {} : _ref$contentContainer,
      _ref$onViewableItemsC = _ref.onViewableItemsChangedImpressionVisible,
      onViewableItemsChangedImpressionVisible = _ref$onViewableItemsC === void 0 ? false : _ref$onViewableItemsC,
      _ref$onEndReachWithSc = _ref.onEndReachWithScroll,
      onEndReachWithScroll = _ref$onEndReachWithSc === void 0 ? true : _ref$onEndReachWithSc,
      _ref$bounces = _ref.bounces,
      bounces = _ref$bounces === void 0 ? true : _ref$bounces,
      _ref$stickySectionHea = _ref.stickySectionHeadersEnabled,
      stickySectionHeadersEnabled = _ref$stickySectionHea === void 0 ? false : _ref$stickySectionHea,
      enableCustomCellRenderer = _ref.enableCustomCellRenderer,
      maxZIndex = _ref.maxZIndex,
      tooltipSectionIndex = _ref.tooltipSectionIndex,
      toolTipIndex = _ref.toolTipIndex,
      toolTipProps = _ref.toolTipProps,
      rnSectionListIsLoading = _ref.isLoading;
    var testID = props.testID,
      onUserAction = props.onUserAction;
    var withSectionListStyles = getWithSectionListStyles();
    var data = withSectionListProps.data,
      appendData = withSectionListProps.appendData;
    var _useState = useState(data),
      sectionListData = _useState[0],
      setSectionListData = _useState[1];
    var _useState2 = useState(section),
      rnSectionList = _useState2[0],
      setRNSectionListData = _useState2[1];
    var mountRef = useRef(true);
    var setOfVisitedIds = useRef(new Set());
    useEffect(() => {
      setSectionListData(data);
    }, [data]);
    useEffect(() => {
      if ((appendData === null || appendData === void 0 ? void 0 : appendData.length) > 0) {
        setSectionListData(prevData => [...prevData, ...(appendData !== null && appendData !== void 0 ? appendData : [])]);
      }
    }, [appendData]);
    useEffect(() => {
      setRNSectionListData(section);
    }, [section]);
    useEffect(() => {
      if ((appendSection === null || appendSection === void 0 ? void 0 : appendSection.length) > 0) {
        setRNSectionListData(prevData => [...prevData, ...(appendSection !== null && appendSection !== void 0 ? appendSection : [])]);
      }
    }, [appendSection]);
    useEffect(() => {
      if (isValidObject(appendRNSectionItem)) {
        var itemPosition = appendRNSectionItem.itemPosition,
          _data = appendRNSectionItem.data;
        if (itemPosition != null && _data != null) {
          setRNSectionListData(prevData => {
            var _a, _b, _c;
            if (!prevData) return prevData;
            var updatedData = [...prevData];
            var currentPos = 0;
            for (var i = 0; i < updatedData.length; i++) {
              var sectionLength = (_c = (_b = (_a = updatedData[i]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
              if (currentPos + sectionLength >= itemPosition) {
                var insertPos = itemPosition - currentPos;
                if (JSON.stringify(updatedData[i].data[insertPos]) !== JSON.stringify(_data)) {
                  updatedData[i].data.splice(insertPos, 0, _data);
                }
                break;
              }
              currentPos += sectionLength;
            }
            return updatedData;
          });
        }
      }
    }, [appendRNSectionItem, data, section]);
    var onViewableItemsChanged = useCallback(_ref2 => {
      var viewableItems = _ref2.viewableItems;
      viewableItems.forEach(_ref3 => {
        var item = _ref3.item,
          index = _ref3.index,
          section = _ref3.section;
        var _a, _b;
        var sectionIndex = rnSectionList === null || rnSectionList === void 0 ? void 0 : rnSectionList.findIndex(sec => sec === section);
        var combinedIndexWithSection = Math.pow(1000, sectionIndex) + (index !== null && index !== void 0 ? index : 0);
        var sendImpression = !((_a = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _a === void 0 ? void 0 : _a.has(combinedIndexWithSection));
        if (sendImpression) {
          (_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.add(combinedIndexWithSection);
          if (item === null || item === void 0 ? void 0 : item.onViewVisibleMetaData) {
            onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, item === null || item === void 0 ? void 0 : item.onViewVisibleMetaData), Object.assign({
              index: combinedIndexWithSection
            }, item));
          }
        }
      });
    }, [rnSectionList, onUserAction]);
    return _jsx(_Fragment, {
      children: withSectionList ? _jsx(View, Object.assign({}, getTestId(testID, 'withSectionList'), {
        children: sectionListData === null || sectionListData === void 0 ? void 0 : sectionListData.map((sectionItem, sectionIndex) => {
          var _ref4 = sectionItem || {},
            list = _ref4.list,
            showDividerWithList = _ref4.showDividerWithList,
            onViewSectionVisibleMetaData = _ref4.onViewSectionVisibleMetaData,
            sectionTitleProps = _ref4.sectionTitleProps,
            cardProps = _ref4.cardProps,
            dividerStyle = _ref4.dividerStyle;
          var flatListJSX = _jsx(FlatList, Object.assign({
            keyExtractor: (item, index) => {
              var _a;
              return ((_a = item === null || item === void 0 ? void 0 : item.sectionTitleProps) === null || _a === void 0 ? void 0 : _a.title) + "_" + index;
            },
            data: list,
            renderItem: _ref5 => {
              var item = _ref5.item,
                index = _ref5.index;
              return _jsx(InView, Object.assign({
                triggerOnce: true,
                onChange: inView => {
                  if (inView && isValidObject(item === null || item === void 0 ? void 0 : item.onViewVisibleMetaData)) {
                    var combinedIndexWithSection = Math.pow(10, sectionIndex) + index;
                    onUserAction(Object.assign({}, item === null || item === void 0 ? void 0 : item.onViewVisibleMetaData), Object.assign({
                      index: combinedIndexWithSection
                    }, item));
                  }
                }
              }, {
                children: _jsx(Component, Object.assign({}, item, {
                  onUserAction: onUserAction
                }))
              }));
            }
          }, showDividerWithList && {
            ItemSeparatorComponent: () => {
              return _jsx(Divider, {
                style: [withSectionListStyles.dividerStyle, dividerStyle]
              });
            }
          }));
          return _jsx(Fragment, {
            children: _jsxs(InView, Object.assign({
              triggerOnce: true,
              onChange: inView => {
                if (inView && isValidObject(onViewSectionVisibleMetaData)) {
                  onUserAction(Object.assign({}, onViewSectionVisibleMetaData), Object.assign({
                    index: sectionIndex
                  }, sectionItem));
                }
              }
            }, {
              children: [isValidObject(sectionTitleProps) && _jsx(SectionTitleWidgetComponent, Object.assign({
                isTitleBold: true,
                style: isFirstItem(sectionIndex) ? withSectionListStyles.firstSectionItem : withSectionListStyles.sectionItem
              }, sectionTitleProps, getTestId(testID, "sectionTitle_" + sectionIndex))), (withSectionListProps === null || withSectionListProps === void 0 ? void 0 : withSectionListProps.wrapListWithCard) ? _jsx(Card, Object.assign({
                withRoundedBorder: true,
                noHorizontalPadding: true,
                paddingToken: "SPACING_8"
              }, cardProps, getTestId(testID, "card_" + sectionIndex), {
                children: flatListJSX
              })) : flatListJSX]
            }))
          }, "single_selection_item_" + sectionIndex);
        })
      })) : withRNSectionList ? _jsx(SectionList, Object.assign({
        sections: rnSectionList !== null && rnSectionList !== void 0 ? rnSectionList : [],
        keyExtractor: (item, index) => {
          var _a;
          return ((_a = item === null || item === void 0 ? void 0 : item.sectionId) !== null && _a !== void 0 ? _a : '') + "-" + index;
        },
        contentContainerStyle: contentContainerStyle,
        ListHeaderComponent: isValidObject(rnSectionListHeaderProps) && _jsx(RNSectionListHeaderComponent, Object.assign({}, rnSectionListHeaderProps, {
          testID: testID
        }))
      }, enableCustomCellRenderer && {
        CellRendererComponent: cellProps => _jsx(View, Object.assign({}, cellProps, {
          style: {
            zIndex: maxZIndex - Number((cellProps === null || cellProps === void 0 ? void 0 : cellProps.index) || 0)
          }
        }, {
          children: cellProps === null || cellProps === void 0 ? void 0 : cellProps.children
        }))
      }, {
        renderItem: _ref6 => {
          var item = _ref6.item,
            index = _ref6.index,
            section = _ref6.section;
          var sectionIndex = rnSectionList === null || rnSectionList === void 0 ? void 0 : rnSectionList.findIndex(sec => sec === section);
          return _jsx(InView, Object.assign({
            triggerOnce: true,
            onChange: inView => {
              if (inView && isValidObject(item === null || item === void 0 ? void 0 : item.onViewVisibleMetaData)) {
                var combinedIndexWithSection = Math.pow(10, index) + index;
                onUserAction(Object.assign({}, item === null || item === void 0 ? void 0 : item.onViewVisibleMetaData), Object.assign({
                  index: combinedIndexWithSection
                }, item));
              }
            }
          }, {
            children: sectionIndex === tooltipSectionIndex ? _jsx(Tooltip, Object.assign({
              isVisible: index === toolTipIndex
            }, toolTipProps, {
              children: _jsx(Component, Object.assign({}, item, {
                onUserAction: onUserAction
              }))
            })) : _jsx(Component, Object.assign({}, item, {
              onUserAction: onUserAction
            }))
          }));
        },
        renderSectionHeader: _ref7 => {
          var section = _ref7.section;
          var _a;
          var _ref8 = section || {},
            _ref8$sectionTitlePro = _ref8.sectionTitleProps,
            sectionTitleProps = _ref8$sectionTitlePro === void 0 ? {} : _ref8$sectionTitlePro;
          var sectionIndex = rnSectionList === null || rnSectionList === void 0 ? void 0 : rnSectionList.findIndex(sec => sec === section);
          return _jsx(InView, Object.assign({
            triggerOnce: true,
            onChange: inView => {
              if (inView && isValidObject(section === null || section === void 0 ? void 0 : section.onViewSectionVisibleMetaData)) {
                var combinedIndexWithSection = Math.pow(10, sectionIndex) + sectionIndex;
                onUserAction(Object.assign({}, section === null || section === void 0 ? void 0 : section.onViewSectionVisibleMetaData), Object.assign({
                  index: combinedIndexWithSection
                }, section));
              }
            }
          }, {
            children: _jsx(SectionTitleWidgetComponent, Object.assign({}, sectionTitleProps, getTestId(testID, "section_" + ((_a = section.sectionTitleProps) === null || _a === void 0 ? void 0 : _a.title))))
          }));
        },
        onViewableItemsChanged: onViewableItemsChangedImpressionVisible && onViewableItemsChanged,
        onEndReachedThreshold: onEndReachedThreshold !== null && onEndReachedThreshold !== void 0 ? onEndReachedThreshold : 0.2,
        onEndReached: () => {
          if ((!mountRef.current || !onEndReachWithScroll) && isValidObject(onEndReachedMetaData) && !(rnSectionListIsLoading !== null && rnSectionListIsLoading !== void 0 ? rnSectionListIsLoading : false)) {
            onUserAction(Object.assign({}, onEndReachedMetaData), {
              data: section
            });
          }
        },
        onScroll: e => {
          mountRef.current = false;
          if (isValidObject(onScrollMetaData)) {
            onUserAction(onScrollMetaData, {
              eventData: e
            });
          }
        },
        ListFooterComponent: !!isLoading && _jsx(LoaderWidgetComponent, Object.assign({}, loaderWidgetProps))
      }, dividerWithList && {
        ItemSeparatorComponent: () => {
          return _jsx(Divider, {
            style: dividerWithListStyle
          });
        }
      }, {
        bounces: bounces,
        stickySectionHeadersEnabled: stickySectionHeadersEnabled
      })) : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};
var RNSectionListHeaderComponent = props => {
  if (!isValidObject(props)) {
    return _jsx(_Fragment, {});
  }
  var _ref9 = props || {},
    growthInventoryWidgetProps = _ref9.growthInventoryWidgetProps,
    testID = _ref9.testID;
  return _jsx(Fragment, {
    children: isValidObject(growthInventoryWidgetProps) && _jsx(GrowthInventoryWidgetComponent, Object.assign({}, growthInventoryWidgetProps, getTestId(testID, "growthInventory")))
  });
};